/**
 * The `Engineer Type` column of the field engineer import (written by `scripts/generate-sn-fe-import.ts`).
 *
 * ONLY `partner` IS USED. It marks an engineer who works for a partner company. `internal` is written by the
 * export for readability and is accepted here, but it says nothing: neither it nor a blank cell can change the
 * flag of an engineer that already exists, so a partner flag set by hand (or by an earlier import) is never undone
 * by a file. A NEW engineer starts internal, which is also what a blank or `internal` cell means. To take an
 * existing engineer back to internal, clear the "Partner engineer" checkbox on their form.
 */

export interface ParsedEngineerType {
  /** true = the cell says `partner`; undefined = it says nothing (blank or `internal`). Never false. */
  isPartner: true | undefined;
  /** The cell held something that is neither `partner`, `internal` nor blank; it is ignored, and the row reports it. */
  invalid: boolean;
}

export function parseEngineerType(raw: string | null | undefined): ParsedEngineerType {
  const value = (raw ?? '').trim().toLocaleLowerCase();
  if (value === 'partner') return { isPartner: true, invalid: false };
  if (value === '' || value === 'internal') return { isPartner: undefined, invalid: false };
  return { isPartner: undefined, invalid: true };
}
